import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getTemplates } from "../../../store/whatsApp/wpThunks";
import FormTemplate from "../from/Form-template";

const Wptemplate = () => {
  const [usertemplates, setUsertemplates] = useState([]);
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const [selectedOption, setSelectedOption] = useState("None");
  const [FormatSelect, setFormatSelect] = useState(null);
  const [Selectedtemplatename, setSelectedtemplatename] = useState(null);

  const handleSelect = (e) => {
    setSelectedOption(e);
  };

  const handleClose = () => setShow(false);

  // Modified handleShow to reset states for creating a new template
  const handleShow = () => {
    setFormatSelect(null); // Reset FormatSelect for new template
    setSelectedtemplatename(null); // Reset Selectedtemplatename for new template
    setShow(true);
  };

  let handleFormatSelect = (value, name) => {
    setShow(true);
    console.log(value, "valuevaluevalue");
    console.log(name, "name");
    setFormatSelect(value);
    setSelectedtemplatename(name);
  };

  const {
    usergetTemplatesFullfill,
    usergetTemplatesError,
    usergetTemplatesByIdFullfill,
    usergetTemplatesByIdError,
  } = useSelector((state) => state.whatsapp);

  console.log(
    usergetTemplatesFullfill,
    "usergetTemplatesFullfillusergetTemplatesFullfillusergetTemplatesFullfillusergetTemplatesFullfill"
  );

  useEffect(() => {
    if (usergetTemplatesFullfill?.template?.length > 0) {
      setUsertemplates(usergetTemplatesFullfill?.template);
    }
  }, [usergetTemplatesFullfill]);

  useEffect(() => {
    dispatch(getTemplates());
  }, []);

  const components = usertemplates?.components?.map((component) => {
    console.log(component, "componentcomponentcomponentcomponent");
    return component;
  });

  console.log(components, "componentscomponentscomponentscomponents");
  console.log(usertemplates, "templatestemplatestemplates");

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Header Section */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-r from-[#50B5FF] to-[#5BA3E0] rounded-2xl mb-6 shadow-lg">
            <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
            </svg>
          </div>
          <h1 className="text-4xl font-bold text-gray-900 mb-4 bg-gradient-to-r from-[#50B5FF] to-[#5BA3E0] bg-clip-text text-transparent">
            WhatsApp Templates
          </h1>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Manage and customize your WhatsApp message templates with ease. Create engaging conversations with pre-built templates.
          </p>
        </div>

        {/* Stats Bar */}
        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6 mb-8">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
            <div className="flex items-center gap-6">
              <div className="text-center">
                <div className="text-2xl font-bold text-[#50B5FF]">{usertemplates?.length || 0}</div>
                <div className="text-sm text-gray-500">Total Templates</div>
              </div>
              <div className="w-px h-8 bg-gray-200"></div>
              <div className="text-center">
                <div className="text-2xl font-bold text-emerald-500">
                  {usertemplates?.filter(t => t.status === 'active')?.length || 0}
                </div>
                <div className="text-sm text-gray-500">Active</div>
              </div>
            </div>
            <button
              onClick={handleShow} // Add onClick to open modal for new template
              className="bg-gradient-to-r from-[#50B5FF] to-[#5BA3E0] hover:from-[#3682B8] hover:to-[#4A94D1] text-white px-6 py-2.5 rounded-xl font-medium transition-all duration-200 shadow-md hover:shadow-lg flex items-center gap-2"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
              </svg>
              Create New Template
            </button>
          </div>
        </div>

        {/* Templates Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3 gap-8">
          {usertemplates?.map((template, index) => (
            <div
              key={template.id}
              className="group bg-white rounded-2xl shadow-sm hover:shadow-xl transition-all duration-300 border border-gray-100 hover:border-[#50B5FF]/20 overflow-hidden"
            >
              {/* Card Header */}
              <div className="bg-gradient-to-r from-[#50B5FF]/5 to-[#5BA3E0]/5 p-6 border-b border-gray-50">
                <div className="flex items-start justify-between">
                  <div className="flex-1">
                    <h3 className="text-xl font-semibold text-gray-900 mb-2 group-hover:text-[#50B5FF] transition-colors duration-200 line-clamp-2">
                      {template.templateName?.length > 20 ? `${template.templateName.substring(0, 20)}...` : template.templateName}
                    </h3>
                    <div className="flex items-center gap-2">
                      <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-[#50B5FF]/10 text-[#50B5FF]">
                        Template #{index + 1}
                      </span>
                      <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-emerald-100 text-emerald-700">
                        Active
                      </span>
                    </div>
                  </div>
                  <div className="flex items-center justify-center w-10 h-10 bg-[#50B5FF]/10污水处理 rounded-xl group-hover:bg-[#50B5FF]/20 transition-colors duration-200">
                    <svg className="w-5 h-5 text-[#50B5FF]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-1.586l-4.707 4.707z" />
                    </svg>
                  </div>
                </div>
              </div>

              {/* Card Body */}
              <div className="p-6">
                <div className="space-y-3 mb-6">
                  {template?.components?.slice(0, 3).map((children, idx) => (
                    <div
                      key={idx}
                      className="relative p-3 bg-gradient-to-r from-gray-50 to-blue-50/30 rounded-xl border border-gray-100 text-sm text-gray-700 hover:bg-gradient-to-r hover:from-[#50B5FF]/5 hover:to-[#5BA3E0]/5 transition-all duration-200"
                    >
                      <div className="absolute left-2 top-3 w-2 h-2 bg-[#50B5FF] rounded-full opacity-60"></div>
                      <div className="pl-4 leading-relaxed">
                        {children?.text?.length > 80 ? `${children?.text?.substring(0, 80)}...` : children?.text}
                      </div>
                    </div>
                  ))}
                  {template?.components?.length > 3 && (
                    <div className="text-center py-2">
                      <span className="text-xs text-gray-500 bg-gray-100 px-3 py-1 rounded-full">
                        +{template.components.length - 3} more components
                      </span>
                    </div>
                  )}
                </div>

                {/* Action Button */}
                {/* <button
                  onClick={() =>
                    handleFormatSelect(template?.components, template.templateName)
                  }
                  className="w-full bg-gradient-to-r from-[#50B5FF] to-[#5BA3E0] hover:from-[#3682B8] hover:to-[#4A94D1] text-white font-semibold py-3 px-6 rounded-xl transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-[#50B5FF]/50 focus:ring-offset-2 shadow-md hover:shadow-lg transform hover:scale-[1.02] active:scale-[0.98] flex items-center justify-center gap-2"
                >
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                  </svg>
                  Edit Template
                </button> */}
              </div>
            </div>
          ))}

          {/* Empty State */}
          {(!usertemplates || usertemplates.length === 0) && (
            <div className="col-span-full flex flex-col items-center justify-center py-16">
              <div className="w-20 h-20 bg-gradient-to-r from-[#50B5FF]/10 to-[#5BA3E0]/10 rounded-2xl flex items-center justify-center mb-6">
                <svg className="w-10 h-10 text-[#50B5FF]/50" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">No Templates Found</h3>
              <p className="text-gray-500 text-center max-w-md mb-6">
                Get started by creating your first WhatsApp template. Templates help you send consistent, professional messages.
              </p>
              <button
                onClick={handleShow} // Add onClick to open modal for new template
                className="bg-gradient-to-r from-[#50B5FF] to-[#5BA3E0] hover:from-[#3682B8] hover:to-[#4A94D1] text-white px-8 py-3 rounded-xl font-medium transition-all duration-200 shadow-md hover:shadow-lg"
              >
                Create Your First Template
              </button>
            </div>
          )}
        </div>

        {/* Modal */}
        {show && (
          <div className="fixed inset-0 z-50 overflow-y-auto">
            {/* Enhanced Backdrop */}
            <div
              className="fixed inset-0 bg-black/50 backdrop-blur-sm transition-opacity"
              onClick={handleClose}
            ></div>

            {/* Modal */}
            <div className="flex min-h-full items-center justify-center p-4">
              <div className="relative w-full max-w-6xl bg-white rounded-2xl shadow-2xl border border-gray-200 overflow-hidden transform transition-all">
                {/* Modal Header */}
                <div className="bg-gradient-to-r from-[#50B5FF] to-[#5BA3E0] px-8 py-6">
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-3">
                      <div className="w-8 h-8 bg-white/20 rounded-lg flex items-center justify-center">
                        <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                        </svg>
                      </div>
                      <div>
                        <h3 className="text-xl font-semibold text-white">
                          {Selectedtemplatename ? "Edit Template" : "Create New Template"}
                        </h3>
                        <p className="text-white/80 text-sm">
                          {Selectedtemplatename
                            ? "Customize your WhatsApp template"
                            : "Create a new WhatsApp template"}
                        </p>
                      </div>
                    </div>
                    <button
                      onClick={handleClose}
                      className="text-white/80 hover:text-white focus:outline-none focus:text-white transition-colors duration-200 p-2 hover:bg-white/10 rounded-lg"
                    >
                      <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                      </svg>
                    </button>
                  </div>
                </div>

                {/* Modal Body */}
                <div className="p-8 max-h-[70vh] overflow-y-auto bg-gray-50/30">
                  <FormTemplate
                    FormatSelect={FormatSelect}
                    Selectedtemplatename={Selectedtemplatename}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Wptemplate;